import { SECTION_TOP_PAD, bottomMarginItemGlobal } from "../../utils/pdfConstants";
import { isSentinelTitle } from "../../../assets/subsectionBlockTemplates";

const NO_AUTO_PAGEBREAK_TYPES = ['julkisivujen_kuntotutkimus', 'julkisivujen_kuntotutkimus_v2', 'ikkuna'];

export async function renderSubsection({
  block,
  content,
  subsectionCounters,
  sectionNumber,
  level = 2,
  renderBlocks,
  reportType,
}) {
  const { data } = block;

  if (isSentinelTitle(data?.title)) return;

  // --- Render inner blocks first ---
  let innerContent = [];
  if (Array.isArray(data.blocks)) {
    await renderBlocks(data.blocks, innerContent, sectionNumber, level + 1);
  }

  // Filter out empty/null blocks (keep your logic style)
const isRealContent = (item) => {
  if (!item) return false;

  // text
  if (typeof item.text === "string") {
    const text = item.text.trim();

    // ignore fallback text ONLY
    if (text === "• Ei toimenpide-ehdotuksia." || text === "Ei toimenpide-ehdotuksia.") {
      return false;
    }

    return text.length > 0;
  }

  // stack
  if (Array.isArray(item.stack)) {
    return item.stack.some(isRealContent);
  }

  // columns
  if (Array.isArray(item.columns)) {
    return item.columns.some(isRealContent);
  }

  // everything else (images, tables, etc.) counts
  return true;
};

const hasContent = innerContent.some(isRealContent);


if (!hasContent) return;


  subsectionCounters[sectionNumber] = (subsectionCounters[sectionNumber] || 0) + 1;
  const subNumber = `${sectionNumber}.${subsectionCounters[sectionNumber]}`;

  const title = (data.title || "").trim();
  const isLisa = /Lisätutkimukset/i.test(title);
  const isOwnPageSection =
    /^(Kuvat|Korjaussuositukset)$/i.test(title);
  const autoBreak =
    isLisa &&
    !NO_AUTO_PAGEBREAK_TYPES.includes(reportType);
  const forcePageBreak =
    autoBreak ||
    isOwnPageSection ||
    data.pageBreakBefore;
  const isLandscape = data.pageOrientation === "landscape";

  const subsectionHeading = {
    text: `${subNumber} ${data.title || "Aliosio"}`,
    style: "subHeading",
    id: `subsection-${Math.random().toString(36).substr(2, 9)}`,
    tocItem: { text: `${subNumber} ${data.title || "Aliosio"}`, level },
    tocMargin: [15 * (level - 1), 0, 0, 0],
    tocStyle: { italics: false, fontSize: 12 },
    margin: [0, forcePageBreak ? -SECTION_TOP_PAD + bottomMarginItemGlobal + 8 : 8, 0, 10],
  };

  if (forcePageBreak) {
    subsectionHeading.pageBreak = "before";
  }
  if (isLandscape) {
    subsectionHeading.pageOrientation = "landscape";
  }

  content.push(subsectionHeading);
  content.push(...innerContent);
  if (isLandscape) {
    // Return to portrait for content that follows this subsection
    content.push({ text: '', pageBreak: 'before', pageOrientation: 'portrait' });
  }
}